import * as types from '../actions/types'
import Immutable from 'immutable'

import { isPrimitive, parametro, parametroConfig } from '../utils/helpers'

const INITIAL_STATE = Immutable.fromJS({
	
	maestras: [],
	modalAddMaestra: {
		show: false,
		data: {
			nombre: '',
			file: null,
			icono: '',
			clasificacion: '',
			guid: '',
		},
		btnDisabled: false
	},
	modalDelete: {
		show: false,
		action: null,
		message: null
	},

	modalProgress: {
		show: false
	}


})

export default function (state = INITIAL_STATE, action) {
	switch(action.type) {
		case types.OBTENER_MAESTRAS:
			return state.set('maestras', Immutable.fromJS(action.payload))
		case types.MOSTRAR_MODAL_ADICIONAR_MAESTRA:
			return state.setIn(['modalAddMaestra', 'show'], action.payload)
		case types.CONMUTAR_SELECCION_MAESTRAS:
			return state.setIn(['maestras', action.payload.index, 'checked'], action.payload.checked)
		case types.CONMUTAR_SELECCION_TODAS_MAESTRAS:
			state.get('maestras').forEach((x, n) => {
				state = state.setIn(['maestras', n, 'checked'], action.payload.checked)
			})
			return state
		case types.MODIFICAR_INPUTS_MAESTRA:
			if (isPrimitive(action.payload.value)) {
				state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
			} else {
				if (action.payload.immutable === false) {
					state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
				} else {
					state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
				}
			}
			
			return state



		case types.MOSTRAR_MODAL_PROGRESS:
			return state.setIn(['modalProgress', 'show'], action.payload)


		default:
			return state
	}
}



// WEBPACK FOOTER //
// ./src/reducers/maestra.js